// extracted by mini-css-extract-plugin
module.exports = {"detailsButton":"MediaDetailsButton_detailsButton__ZVKVz"};